'use client';
import useEventsStream from '../hooks/use-events-stream';
import MarketEventListWithSkeleton from './MarketEvent';
import { Loader2 } from 'lucide-react';
import SwrLocalCacheProvider from '@/lib/swr/SwrLocalCacheProvider';

const PAGE_SIZE = 6;

/**
 * 经 openDrawer 渲染在根布局抽屉里（predic layout 之外），
 * 自带缓存 Provider 才能命中 predic 的本地缓存中间件
 */
export default function MarketPulse() {
  return (
    <SwrLocalCacheProvider>
      <MarketPulseInner />
    </SwrLocalCacheProvider>
  );
}

function MarketPulseInner() {
  const { list, isLoading, isValidating, setSentinelRef } = useEventsStream({
    orderBy: 'latest',
    pageSize: PAGE_SIZE,
  });

  return (
    <>
      <MarketEventListWithSkeleton loading={isLoading} list={list} />
      {/* sentinel 进入视口自动加载下一页 */}
      <div ref={setSentinelRef} className="flex items-center justify-center py-2">
        {isValidating && <Loader2 className="animate-spin" />}
      </div>
    </>
  );
}
